module.exports = __webpack_public_path__ + "static/media/DetailsTable.51374b4f.css";


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/StandardPerformance/DetailsTable.css
// module id = 1153
// module chunks = 0